import Vue from 'vue'
import moment from 'moment'

Vue.filter('capitalize', function (value) {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('summarize', function (value, limit) {
	if (!value) return ''

	value = value.toString()
	if (value.length >= limit) {
		value = `${value.substring(0, limit - 3)}...`
	}

	return value
})

Vue.filter('dateFormatter', function (date, format = 'MMM[.] DD, YYYY hh:mm A') {
	if (!date) return '--'
	return moment(date).format(format)
})

export default Vue
